import { controls, grouped } from "../controls";
const assign_sevikas_to_villages = {
    label: "Assign User To Villages/Ward",
    pageLabel: "Assign User To Village/Ward", starting: true, url: "autogen",
    formActions: { edit: { allow: true }, delete: { allow: true } },
    pageType: "history",
    bulk: { columns: ["user_id", "village_id"] },
    formTabs:
    {
        allTabs: [
            { label: "General", uid: "general" },
            { label: "Bulk", uid: "bulk" }
        ]
    },
    filter: [
        ...controls.displayText({ tab: "filter", label: "User" }),
        ...controls.oc({ tab: "filter", c: "User", placeHolder: "User Code", name: "AssignSevikaToVillage-user-user_code", fastpath: "users" }),
        ...controls.showData({ tab: "filter", displaytype: "capital", data: "AssignSevikaToVillage-user-user_display" }),
        ...controls.displayText({ tab: "filter", label: "Village" }),
        ...controls.oc({ tab: "filter", c: "Village", placeHolder: "Village Code", name: "AssignSevikaToVillage-village-village_code", fastpath: "villages" }),
        ...controls.showData({ tab: "filter", displaytype: "capital", data: "AssignSevikaToVillage-village-village_display" }),
        ...controls.displayText({ tab: "filter", label: "My User Id" }),
        ...controls.numberOnly({ tab: "filter", placeHolder: "", name: "my_user_id", maxlength: 200 }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ]
    , form: [
        ...controls.displayText({ tab: "general", label: "User", star: false }),
        ...controls.oc({ tab: "general", c: "User", placeHolder: "User Code", name: "user_code", fastpath: "users", hidden: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "user_display" }),
        ...controls.displayText({ tab: "general", label: "Village", star: false }),
        ...controls.oc({ tab: "general", c: "Village", placeHolder: "Village Code", name: "village_code", fastpath: "villages", hidden: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "village_display" }),
    ]
    , history: {
        perPage: 10,
        reportHeader: "Assign Sevikas To Villages",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
            { Header: "User", accessor: "AssignSevikaToVillage-user-user_display", },
            { Header: "Village/Ward", accessor: "AssignSevikaToVillage-village-village_display", },
        ]
    }
};
export default assign_sevikas_to_villages;